if ($("#news-page")) {
    const vm = new Vue({
      el: "#news-page",
      data: {
        scheduleDaysCount: "",
      }
    });
   
  }